<template>
  <router-view />
</template>

<script>
  export default {
    name: 'EuromatIndex',
  }
</script>
